import { Button } from 'components/Button/Button'
import { MyTextField } from 'components/ReactHookForm/MyTextField'
import { FC, RefObject } from 'react'
import { FormProvider, SubmitErrorHandler, SubmitHandler, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EMSNSearchForm } from 'models/eMSN'

export interface EMSNSearchProps {
  handleSubmit: SubmitHandler<EMSNSearchForm>,
  formMethods: UseFormReturn<EMSNSearchForm>,
  formErrorAlertWrapper: RefObject<HTMLDivElement>
}

const searchFormButtonClasses = [
  'ds-c-button',
  'my-u-mt--4',
  'my-u-md-mt--18',
  'my-u-py--8',
  'my-u-px--12',
  'my-u-width--full'
].join(' ')

export const EMSNSearch: FC<EMSNSearchProps> = ({
  handleSubmit,
  formMethods,
  formErrorAlertWrapper
}) => {
  const { t } = useTranslation('eMSNPage')

  const handleError: SubmitErrorHandler<EMSNSearchForm> = () => {
    formErrorAlertWrapper.current?.focus()
  }

  return (
    <div className='my-u-pt--8'>
      <FormProvider {...formMethods}>
        <form
          className='ds-l-form-row'
          onSubmit={(e) => {
            const asyncSubmit = async () => {
              const formData = formMethods.getValues()
              const hasErrors = formMethods.formState.errors.claimNumber
              await formMethods.handleSubmit(handleSubmit, handleError)(e)
              if (!hasErrors) {
                formMethods.reset(formData)
              }
            }
            asyncSubmit()
          }}
        >
          <MyTextField
            name='claimNumber'
            className='ds-l-col--12 ds-l-md-col--6'
            fieldClassName='my-u-max-width--none'
            label={`${t('emsn-search.claim-number.label')} ${t('emsn-search.claim-number.label-suffix')}`}
            labelClassName='my-u-mt--4'
            rules={{
              pattern: {
                value: /^$|^[a-zA-Z0-9]{7,}$/, // Empty string or 7+ alphanumeric characters
                message: t('emsn-search.claim-number.error')
              }
            }}
          />
          <div className='ds-l-col--6 ds-l-md-col--auto'>
            <Button
              className={`${searchFormButtonClasses} ds-c-button--solid ds-c-button--alternate`}
              type='submit'
            >
              {t('emsn-search.search-button')}
            </Button>
          </div>
          <div className='ds-l-col--6 ds-l-md-col--auto'>
            <Button
              className={`${searchFormButtonClasses} my-u-px--0 `}
              type='button'
              onClick={() => {
                formMethods.reset({ claimNumber: '' })
                handleSubmit(formMethods.getValues())
              }}
            >
              {t('emsn-search.clear-search')}
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}
